// DocteurLogic.js
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import api from '../../../service/caller'; // Ajustez le chemin selon votre structure
import { FaPen, FaTrash, FaPlus } from "react-icons/fa";


export const useConsultationLogic = () => {
  const navigate = useNavigate();
  const [UserData, setUserData] = useState([]);
  const [patientData, setPatientData] = useState([]);
  const [vitalSignsData, setVitalSignsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [followUpDate, setFollowUpDate] = useState('');
  const [text, setText] = useState('');
  const queryParams = new URLSearchParams(location.search);
  const patientId = queryParams.get('patient_id');
  const appointmentId = queryParams.get('appointmentId');


  const [formData, setFormData] = useState({
    hospitalId: '',
    otherdetails: '',
    patientId: patientId ?? '',
    birthDate: '',
    aigenerating: text,
    doctor_question: [{ question: '', response: '' }],
    medicalHistory: [{ condition: '', description: '', dateDiagnosed: '' }],
    allergies: [{ type: '', description: '' }],
    ongoingMedications: [{ medication: '', dosage: '', frequency: '' }],
    surgeries: [{ procedureName: '', date: '', additionalNotes: '' }],
    familyMedicalHistory: [{ type: '', description: '' }],
    symptoms: [{ onsetDate: '', symptoms: '', severity: '', additionalNotes: '' }],
    diagnosis: [{ diagnosis: '', testsConducted: '', testResults: '', diagnosticNotes: '', nextSteps: '' }],
    visitLogs: [{ date: '', symptoms: '', diagnosis: '', treatment: '' }],
    prescriptions: [{
      medicationName: '',
      dosage: '',
      frequency: '',
      duration: '',
      specialInstructions: '',
      prescribingDoctor: '',
      pharmacyNotes: '',
      attachment: ''
    }]
  });

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        // console.log(response?.data);

        setUserData(response.data);
        setFormData((prevFormData) => ({
          ...prevFormData,
          hospitalId: response.data?.hospital_id?._id || '',
        }));
      } catch (error) {
        toast.error("Failed to fetch data");
      }
    };

    const fetchPatientData = async () => {
      try {
        if (patientId) {
          const response = await api.get(`/clinic/getpatient/${patientId}`);
          setPatientData(response.data);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des données du patient:', error);
      } finally {
        setLoading(false);
      }
    };


    // /signvitalforappointment/
    const fetchVitalSignsData = async () => {
      try {
        if (patientId) {
          const response = await api.get(`/clinic/signvitalforappointment/${appointmentId}`);
          setVitalSignsData(response?.data?.signVitaldata);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des données du patient:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchVitalSignsData();
    fetchPatientData();
    fetchLoggedUserData();
  }, [patientId]);


  // console.log(vitalSignsData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleArrayFieldAdd = (fieldName, emptyObject) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: [...prev[fieldName], emptyObject]
    }));
  };

  const handleArrayFieldRemove = (fieldName, index) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: prev[fieldName].filter((_, i) => i !== index)
    }));
  };

  const handleArrayFieldChange = (fieldName, index, key, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: prev[fieldName].map((item, i) =>
        i === index ? { ...item, [key]: value } : item
      )
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedFormData = {
      hospitalId: '67a4e4000a3e5d37ee70800e',
      doctorId: UserData._id,
      patientId: formData.patientId,
      otherdetails: formData.otherdetails || 'No details',
      medicalHistory: formData.medicalHistory,
      allergies: formData.allergies,
      ongoingMedications: formData.ongoingMedications,
      surgeries: formData.surgeries,
      familyMedicalHistory: formData.familyMedicalHistory,
      symptoms: formData.symptoms,
      diagnosis: formData.diagnosis,
      visitLogs: formData.visitLogs,
      prescriptions: formData.prescriptions,
      birthDate: formData.birthDate,
      aigenerating: text,
      followUp: followUpDate,
    };
    // console.log(updatedFormData);

    try {
      const response = await api.post('api/consultations', updatedFormData);
      if (response.status === 200 || response.status === 201) {
        navigate(`/hospitaladmin/telemedecine/ordornance?consultationId=${response?.data?._id}&patientId=${patientId}`);
        toast.success("Consultation ended successfully!");
      } else {
        toast.error(response.data.message || "Failed to end consultation. Please try again.");
      }
    } catch (error) {
      toast.error(`Error: ${error?.response?.data?.message || 'An unexpected error occurred. Please try again.'}`);
      console.error('Error:', error?.response || 'No error message available.');
    }
  };

  // semia


  // endsemia

  //   const handleQuickSelect = (e, days) => {
  //     e.preventDefault()
  //     const date = new Date();
  //     date.setDate(date.getDate() + days);
  //     // setFollowUpDate(date.toISOString().split('T')[0]);
  //   setFollowUpDate(date); // Passe l'objet Date directement
  //   };

  const handleQuickSelect = (e, days) => {
    e.preventDefault();
    const date = new Date();
    date.setDate(date.getDate() + days);

    // Format the date to 'YYYY-MM-DD'
    const formattedDate = date.toISOString().split('T')[0];

    // Set the formatted date as followUpDate
    setFollowUpDate(formattedDate);
  };

  const renderDynamicFields = (fieldName, fields, buttonText, emptyObject) => (
    <div className="mt-4">
      <h3 className="mb-3">{buttonText}</h3>
      {/* Itération sur les éléments dans formData[fieldName] */}
      {formData[fieldName].map((item, index) => (
        <div key={index} className="border rounded p-3 mb-3">
          <div className="row g-3">
            {/* Champ modifiable pour le nom (name) */}
            <div className="col-12 label-container">
              <input
                type="text"
                value={item.name || ''}  // Le name modifiable
                onChange={(e) => handleNameEdit(fieldName, index, e.target.value)}  // Mettre à jour le name
                className="form-control editable-label"
                placeholder="Nom du champ"
              />
              <FaPen className="edit-icon" />
            </div>
  
            {/* Itération sur les champs définis dans 'fields' */}
            {fields.map(({ name, type, placeholder }) => (
              <div key={name} className="col-md-4">
                <input
                  type={type}
                  className="form-control"
                  placeholder={placeholder}
                  value={item[name] || ''}
                  onChange={(e) => handleArrayFieldChange(fieldName, index, name, e.target.value)}
                />
              </div>
            ))}
  
            {/* Bouton pour supprimer un champ */}
            <div className="col-auto">
              <button
                type="button"
                className="btn btn-danger text-white"
                onClick={() => handleArrayFieldRemove(fieldName, index)}
              >
                ×
              </button>
            </div>
          </div>
        </div>
      ))}
      
      {/* Bouton pour ajouter un nouvel élément */}
      <button
        type="button"
        className="btn btn-secondary mb-4"
        onClick={() => handleArrayFieldAdd(fieldName, emptyObject)}
      >
        + {buttonText}
      </button>
    </div>
  );
  
  // Fonction pour gérer la modification du name
  const handleNameEdit = (fieldName, index, newName) => {
    const updatedFormData = { ...formData };
    updatedFormData[fieldName][index].name = newName;  // Met à jour le name du champ
    setFormData(updatedFormData);  // Met à jour l'état de formData avec le nouveau name
  };
  




  return {
    UserData,
    patientId,
    patientData,
    vitalSignsData,
    loading,
    formData,
    followUpDate,
    text,
    ToastContainer,
    handleInputChange,
    handleArrayFieldAdd,
    handleArrayFieldRemove,
    handleArrayFieldChange,
    handleSubmit,
    handleQuickSelect,
    renderDynamicFields,
    setFollowUpDate
  };
};